import { IImportHistoryResult } from '@features/import-history/import-history-store/import-history.interface';
import { IDeliveryMethod } from '@features/organizations/store/organizations.interface';
import { IFilterOptions, IPagingResponse } from '@shared/utility/global-enums';

import { IPagingRequest } from '@shared/utility/global-enums';

export interface IReport {
  // reportUID: string;
  // name: string;
  // dateCreated: Date;
  // status: string;
  // metersCount: number;
  deliveryMethodUID: string;
  hasFile: boolean;
  hasErrorFile: boolean;
  numOfMeters: number;
  reportConfigUID: string;
  reportName: string;
  reportStatusID: number;
  reportTemplateID: number;
  reportUID: string;
  scheduledDate: Date;
}
export interface IReportConfig {
  reportConfigUID: string;
  reportConfigName: string;
  reportTemplateID: number;
  fileName: string;
  deliveryMethodUID: string;
  frequency: string;
  manualDates: IManualDates | null;
  useEstimatedMissingData: boolean;
  useEstimatedNotValidData: boolean;
  reportConfigStatusID: ReportConfigStatus;
  meterGroupUIDs: string[];

  latestReports: IReport[] | null;
}
export enum DeliveryMethod {
  SFTP = 'SFTP',
  EMAIL = 'EMAIL',
  FTP = 'FTP',
  API = 'API',
  DOWNLOAD = 'DOWNLOAD',
}

export interface IManualDates {
  startDate: Date;
  dates: Date[];
  hour: number;
  minute: number;
}
export interface IReportState {
  reportConfigs: IReportResult;
  selectedReportConfig: IReportConfig;
  pagingRequest: IPagingRequest;
  filter: {
    ReportConfigStatus: ReportConfigStatus[];
    MeterGroupUID: string[];
    ReportTemplateID: number[];
    DeliveryMethodUID: string[];
  };
  filterOptions: IFilterOptions[];
  search: string;
  error: string | null;
  isNewReportConfig: boolean;
  templates: any;
  meterGroups: any[];
  deliveryMethods: any[];
  validationErrors: any;
  reportDrawers: {
    reportConfig: boolean;
  };
}

export interface IReportResult {
  items: IReportConfig[];
  pagingInfo: IPagingResponse;
  isLoading: boolean;
}

export enum ReportConfigStatus {
  Active = 1,
  Suspended = 2,
  Deleted = 3,
}
export enum ReportStatus {
  Generating = 1,
  FailedToGenerate = 2,
  Delivering = 3,
  FailedToDeliver = 4,
  Delivered = 5,
  Partial = 6,
}
